import { render, staticRenderFns } from "./ProWhy4.vue?vue&type=template&id=6c35f767&scoped=true&"
import script from "./ProWhy4.vue?vue&type=script&lang=js&"
export * from "./ProWhy4.vue?vue&type=script&lang=js&"
import style0 from "./ProWhy4.vue?vue&type=style&index=0&id=6c35f767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c35f767",
  null
  
)

export default component.exports